export function Separator() {
  return (
    <div
      style={{
        backgroundColor: "#1a70d8",
        width: "auto",
        height: ".1rem",
        marginTop: ".2rem",
        marginBottom: ".2rem",
      }}
    />
  );
}
